import React from "react";
import { Row, Col, Typography, Card, Button } from "antd";
import { ClockCircleOutlined, HomeOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import teamIllustration from "../assets/team-illustration.jpg"; 

const { Title, Paragraph, Text } = Typography;

const CareersPage = () => {
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate("/job-application-form");
  };

  return (
    <div
      style={{
        background: "#fff",
        padding: "60px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Top Section */}
        <Row
          justify="space-between"
          align="middle"
          style={{ paddingBottom: "60px" }}
        >
          <Col xs={24} lg={12}>
            <Title level={2} style={{ color: "#5c007a", marginBottom: "16px" }}>
              Join The Yalla Nellab Team
            </Title>
            <Paragraph style={{ maxWidth: "500px", fontSize: "16px" }}>
              Be part of a movement that unites communities through sport. At
              Yalla Nellab, we believe in the power of play to create
              connection, confidence and change.
            </Paragraph>
          </Col>

          <Col xs={24} lg={10} style={{ textAlign: "right" }}>
            <img
              src={teamIllustration}
              alt="Team Illustration"
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </Col>
        </Row>

        {/* Open Roles Section */}
        <div style={{ maxWidth: "900px", paddingBottom: "60px" }}>
          <Title level={3} style={{ marginBottom: "30px" }}>
            Open Roles
          </Title>

          {/* Outer Bordered Box */}
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              padding: "24px",
              background: "#fff",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            {/* Inner Card 1 */}
            <Card
              bordered
              style={{
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                background: "#fff",
              }}
            >
              <Row justify="space-between" align="middle">
                <Col xs={24} md={16}>
                  <Title level={5} style={{ marginBottom: "8px" }}>
                    Product Designer
                  </Title>
                  <Paragraph style={{ marginBottom: "12px" }}>
                    We are looking for a Product designer with experience in Figma
                    designing websites and Photoshop tools and a well-made
                    portfolio.
                  </Paragraph>
                  <div
                    style={{
                      display: "flex",
                      gap: "16px",
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    <Text>
                      <ClockCircleOutlined /> Full Time
                    </Text>
                    <Text>
                      <HomeOutlined /> Remote
                    </Text>
                  </div>
                </Col>
              </Row>
            </Card>

            {/* Inner Card 2 */}
            <Card
              bordered
              style={{
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                background: "#fff",
              }}
            >
              <Row justify="space-between" align="middle">
                <Col xs={24} md={16}>
                  <Title level={5} style={{ marginBottom: "8px" }}>
                    Football Referee
                  </Title>
                  <Paragraph style={{ marginBottom: "12px" }}>
                    We are looking for a professional referee to oversee the
                    tournament matches.
                  </Paragraph>
                  <div
                    style={{
                      display: "flex",
                      gap: "16px",
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    <Text>
                      <ClockCircleOutlined /> Full Time
                    </Text>
                    <Text>
                      <HomeOutlined /> Onsite
                    </Text>
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
        </div>

        {/* How to Apply */}
        <div
          style={{
            maxWidth: "900px",
            borderTop: "1px solid #eee",
            paddingTop: "40px",
          }}
        >
          <Title level={3} style={{ marginBottom: "20px" }}>
            How to Apply
          </Title>
          <Paragraph style={{ fontSize: "16px", lineHeight: "1.8", marginBottom: "24px" }}>
            Ready to join our team? Click the "Apply Now" button next to any open position 
            to start your application process. Our online application form makes it easy to 
            submit your details and documents in one place.
          </Paragraph>
          <Button 
            type="primary" 
            size="large"
            onClick={handleApplyNow}
            style={{
              background: "#5c007a",
              borderColor: "#5c007a",
              padding: "0 32px",
              height: "48px",
              fontSize: "16px",
            }}
          >
            Start Your Application <ArrowRightOutlined />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CareersPage;